var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPhotography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M4.44,4.44L5.86,5.86L4,7h6l1.83,-2H20c1.1,0 2,0.9 2,2v12c0,0.05 -0.01,0.1 -0.02,0.16L20,17.17V7h-4.05l-1.83,-2H9.88L8.9,6.07zM20.49,23.31L18.17,21H4c-1.1,0 -2,-0.9 -2,-2V7c0,-0.59 0.27,-1.12 0.68,-1.49l-2,-2L2.1,2.1l19.8,19.8L20.49,23.31zM9.19,12.02C9.08,12.33 9,12.65 9,13c0,1.66 1.34,3 3,3c0.35,0 0.67,-0.08 0.98,-0.19L9.19,12.02zM16.17,19l-1.68,-1.68C13.76,17.75 12.91,18 12,18c-2.76,0 -5,-2.24 -5,-5c0,-0.91 0.25,-1.76 0.68,-2.49L4.17,7H4v12H16.17zM14.81,11.98l2.07,2.07C16.96,13.71 17,13.36 17,13c0,-2.76 -2.24,-5 -5,-5c-0.36,0 -0.71,0.04 -1.06,0.12l2.07,2.07C13.85,10.49 14.51,11.15 14.81,11.98z",
    transform: "scale(0.7) translate(4.8, 4.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhotography);
export default __webpack_public_path__ + "static/media/no_photography.928ba4267b053596da995e2aecb50a31.svg";
export { ForwardRef as ReactComponent };